import { useMemo } from 'react';
import { tariffBuyWhenDisableAdsModalAnalytics } from 'reactApp/appHelpers/featuresHelpers/features/disableAdsScreen';

export function useDisableAdsAnalytics(analyticsFromQuery?: string) {
    return useMemo(() => {
        if (analyticsFromQuery && tariffBuyWhenDisableAdsModalAnalytics?.hasOwnProperty(analyticsFromQuery)) {
            return { paySource: 'modal_noads_tariff', ...tariffBuyWhenDisableAdsModalAnalytics[analyticsFromQuery] };
        }
        return {
            actionClick: 'modal-noads-click',
            actionShow: 'modal-noads-show',
            paySource: 'modal_noads_tariff',
        };
    }, [analyticsFromQuery, tariffBuyWhenDisableAdsModalAnalytics]);
}
